import React from 'react';
import s from './Navbar.module.css';
import {NavLink} from "react-router-dom";

const Navbar = (props) => {

    /*let friends = [
        {id: 1, name: 'Olga'},
        {id: 2, name: 'Sveta'},
        {id: 3, name: 'Anna'},
    ]*/

/*  let friendsElements = props.store.friends.map( f => <Friend name={f.name} id={f.id}/>);*/

    /*let dialogsElements =  props.state.dialogs.map( d => <DialogItem name={d.name} id={d.id} /> );*/


    /*/!**!/let friends = [
        {id: 1, name: 'Olga'},
        {id: 2, name: 'Sveta'},
        {id: 3, name: 'Anna'},
        {id: 4, name: 'Alina'},
    ]/!**!/*/

    return (
        <nav className={s.nav}>
            <div className={s.button}>
                <NavLink to="/profile" activeClassName={s.button.active}>Profile</NavLink>
            </div>
            <div className={s.button}>
                <NavLink to="/dialogs" activeClassName={s.button.active}>Messages</NavLink>
            </div>
            <div className={s.button}>
                <NavLink to="/users" activeClassName={s.button.active}>Users</NavLink>
            </div>
            <div className={s.button}>
                <a>Music</a>
            </div>
            <div className={s.button}>
                <a>Settings</a>
            </div>
           {/*<div className={s.item}>
                <a>Friends</a></div>
            <div>
                <Friend state={props.state.friends}/>
                { friendsElements }
            </div>*/}
        </nav>
    )
}

export default Navbar;